import { Observable, of } from 'rxjs';
import {
  CustomAction, User,
} from '@nimmsta/ng-commons-lib';

export class CheckSecondaryUserAction extends CustomAction<User> {
  private forSecondary: boolean;

  constructor(text: string, forSecondary: boolean) {
    super(text);
    this.forSecondary = forSecondary;
  }

  override isEnabled(item: User): Observable<boolean> {
    return of(item.isSecondaryOrgMember === this.forSecondary);
  }
}
